import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

import { locationPermissionFromDenied } from './utils';

export const selectLocation = createKeySelector('location');

export const getPosition = createSelector(selectLocation, (location) => location.position);

export const getLatitude = createSelector(getPosition, (position) => position?.lat);

export const getLongitude = createSelector(getPosition, (position) => position?.lon);

export const getPermissionDenied = createSelector(selectLocation, (location) => location.denied);

export const getLocationPermission = createSelector(getPermissionDenied, (denied) =>
  locationPermissionFromDenied(denied)
);

export const getLocationTimeout = createSelector(selectLocation, (location) => location.timeout);

export const getLocationDismissed = createSelector(
  selectLocation,
  (location) => location.dismissed
);
